import { useEffect } from 'react';

import { UnifiedConnectionDtoProvider } from '@/api/generated';
import useIntegrationsAuth from '@/components/Integrations/hooks/useIntegrationsAuth';

const HubspotAuth = () => {
  const { triggerUnifiedConnection } = useIntegrationsAuth();
  useEffect(() => {
    triggerUnifiedConnection(UnifiedConnectionDtoProvider.hubspot);
  }, []);
  return <></>;
};

export default HubspotAuth;
